import React from "react";

/** Care & Preservation: the hand-wash tub from garment care labels, with a heart for care. */
const CareIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="2 5.5 20 15.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8.5c1.5 1.4 3 1.4 4.5 0s3-1.4 4.5 0 3 1.4 4.5 0 3-1.4 4.5 0"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.6 11.5 5.4 19a1.3 1.3 0 0 0 1.27 1h10.66a1.3 1.3 0 0 0 1.27-1l1.8-7.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.6 9.7 15.3a1.45 1.45 0 0 1 2.05-2.05l.25.25.25-.25a1.45 1.45 0 0 1 2.05 2.05Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CareIcon;
